const state = {
  profile: {}
}

const getters = {
  getProfile: state => state.profile,
  profileLoaded: state => {
    return state.profile.uid !== undefined
  },
}

const actions = {}

const mutations = {
  updateProfile (state, profile) {
    state.profile = { ...profile }
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
